module.exports = __webpack_public_path__ + "static/media/marketing-main.f4793f78.svg";